module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("London, 1898")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("If he slit the body from sternum to groin and peeled back the flesh, he could see what made a woman tick. If he probed a little deeper into that steamy, sticky mess, he could remove her pulsing heart and examine it. Maybe at last he could understand what made him different.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Precision. That was the key. Each cut, each motion must be meticulous, following a careful order he’d designed for himself. It was akin to a schematic, an exquisite plan. Unfortunately the insides of a woman were so messy. There must be a way to suction off the blood. He should figure that out. It would make his work so much easier.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He watched the woman’s eyes as she beheld her beating heart in his hand and continued to gaze into them until they went from wide and horrified to blank and glassy. Then he knew her workings ticked no longer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He positioned her body in his pre-arranged pattern, keeping her heart for himself. Removing his gloves, he packed them into his black satchel and clicked the latch closed. He rose, removed his smock and stowed it too in the case. Then he checked his overcoat for traces of blood—wouldn’t do to take the messiness away from the scene with him. After brushing away a spot of dirt from the broadcloth, he decided he was in as pristine a condition as when he’d arrived. He strode away from the sprawled body in the alley, swinging his satchel lightly and whistling a tune.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a pleasant night and he had accomplished much.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ceb821da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426890963_fm03.vue
// module id = 69
// module chunks = 0